import React from 'react';
import {
  FlameIcon,
  SparklesIcon,
  TrophyIcon,
  CalendarIcon,
  StarIcon,
  LockIcon,
  QuestionMarkIcon,
  LevelUpIcon,
  AiDetectIcon,
  HumanizeIcon,
  PlagiarismIcon,
  TripleThreatIcon,
  BalancedIcon
} from '../../icons/gamification';

// Map badge ID to appropriate icon component
export const getBadgeIcon = (badgeId, tier = 1, className = 'h-6 w-6') => {
  // Default icon if no match is found
  let IconComponent = TrophyIcon;
  
  // Map of badge IDs to their corresponding icon components
  const iconMap = {
    // General badges
    'consistency_champion': FlameIcon,
    'word_wizard': SparklesIcon,
    'document_detective': StarIcon,
    'speed_demon': LevelUpIcon,
    'weekend_warrior': CalendarIcon,
    'full_spectrum': StarIcon,
    'perfect_week': CalendarIcon,
    'comeback_kid': LevelUpIcon,
    'quick_draw': LevelUpIcon,
    'deep_dive': SparklesIcon,
    
    // Feature-specific badges
    'ai_detective': AiDetectIcon,
    'humanization_expert': HumanizeIcon,
    'plagiarism_hunter': PlagiarismIcon,
    'triple_threat': TripleThreatIcon,
    'balanced_analyzer': BalancedIcon,
    
    // Secret badges
    'settings_savvy': QuestionMarkIcon,
    'profile_perfectionist': QuestionMarkIcon,
    'easter_egg_hunter': QuestionMarkIcon,
    'night_shift': QuestionMarkIcon,
    'weekend_binge': QuestionMarkIcon,
    'completionist': QuestionMarkIcon,
    
    // Secret feature-specific badges
    'ai_nemesis': AiDetectIcon,
    'humanization_wizard': HumanizeIcon,
    'plagiarism_guardian': PlagiarismIcon
  };
  
  // Look up icon in map
  if (iconMap[badgeId]) {
    IconComponent = iconMap[badgeId];
  }
  
  // Return the icon with tier-specific styling
  return <IconComponent className={getTierColorClass(tier, className)} />;
};

// Return a badge icon for locked/undiscovered badges
export const getLockedBadgeIcon = (isSecret = false, className = 'h-6 w-6') => {
  const IconComponent = isSecret ? QuestionMarkIcon : LockIcon;
  return <IconComponent className={`text-gray-400 dark:text-gray-600 ${className}`} />;
};

// Get color class based on badge tier
export const getTierColorClass = (tier, baseClass = '') => {
  const tierColorMap = {
    1: 'text-yellow-500',           // Bronze
    2: 'text-gray-400',             // Silver
    3: 'text-yellow-400',           // Gold
    4: 'text-blue-400',             // Platinum
    5: 'text-purple-500',           // Diamond
    6: 'text-green-500',            // Emerald
    7: 'text-pink-500',             // Ruby
    8: 'text-indigo-500'            // Sapphire
  };
  
  const colorClass = tierColorMap[tier] || 'text-gray-700';
  return `${baseClass} ${colorClass}`;
};

// Get badge tier name
export const getTierName = (tier) => {
  const tierNames = {
    1: 'Bronze',
    2: 'Silver',
    3: 'Gold',
    4: 'Platinum',
    5: 'Diamond',
    6: 'Emerald',
    7: 'Ruby',
    8: 'Sapphire'
  };
  
  return tierNames[tier] || 'Unknown';
}; 